/* eslint-disable react/no-multi-comp */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import * as PaymentsActions from "../../actions/paymentsActions";

const CARD_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#3E4751",
      color: "#1D1F21",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": {
        color: "#fce883",
      },
      "::placeholder": {
        color: "#3E4751",
      },
    },
    invalid: {
      iconColor: "#ff0000",
      color: "#ff0000",
    },
  },
};

const CardField = ({ onChange }) => (
  <div className="FormRow">
    <label className="FormRowLabel">
      Card Details
    </label>
    <CardElement options={CARD_OPTIONS} onChange={onChange} />
  </div>
);

const Field = ({
  label,
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
}) => (
  <div className="FormRow">
    <label htmlFor={id} className="FormRowLabel">
      {label}
    </label>
    <input
      className="FormRowInput"
      id={id}
      type={type}
      placeholder={placeholder}
      required={required}
      autoComplete={autoComplete}
      value={value}
      onChange={onChange}
    />
  </div>
);

const ErrorMessage = ({children}) => (
  <div className="ErrorMessage" role="alert">
    <svg width="16" height="16" viewBox="0 0 17 17">
      <path
        fill="#FFF"
        d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
      />
      <path
        fill="#6772e5"
        d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
      />
    </svg>
    {children}
  </div>
);

const SubmitButton = ({processing, error, children, disabled}) => (
  <button
    className={`SubmitButton button button-dark-grey ${error ? 'SubmitButton--error' : ''}`}
    type="submit"
    disabled={processing || disabled}
  >
    {processing ? 'Processing...' : children}
  </button>
);

function PaymentCardForm(props) {
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [error, setError] = useState("");
  const [cardComplete, setCardComplete] = useState(false);
  const stripe = useStripe();
  const elements = useElements();

  const onPaymentMethodSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    const card = elements.getElement(CardElement);
    if (card == null) {
      return;
    }

    if (error) {
      card.focus();
      return;
    }

    if (cardComplete) {
      setPaymentLoading(true);
    }
    props.dispatch(
      PaymentsActions.setUpIntent(async (response) => {
        if (response.status) {
          const clientSecret = response.data.clientSecret;
          const paymentResult = await stripe.confirmCardSetup(clientSecret, {
            payment_method: {
              card: card,
              billing_details: {
                name: name,
                address: {
                  line1: address,
                  city: city,
                  state: state,
                  postal_code: zip,
                },
              },
            },
          });
          setPaymentLoading(false);
          if (paymentResult.error) {
            alert(paymentResult.error.message);
          } else {
            if (
              paymentResult.setupIntent &&
              paymentResult.setupIntent.status === "succeeded"
            ) {
              card.clear();
              props.onAddCardRequest && props.onAddCardRequest();
            }
          }
        } else {
          setPaymentLoading(false);
        }
      })
    );
  };
  return (
    <div className="row form">
      <div className="col-sm-12">
        <form
          id="payment-form"
          className="Form"
          onSubmit={onPaymentMethodSubmit}
        >
          <fieldset className="FormGroup">
            <CardField
              onChange={(event) => {
                setError(event.error);
                setCardComplete(event.complete);
              }}
            />
          </fieldset>
          <fieldset className="FormGroup">
            <Field
              label="Name"
              id="name"
              type="text"
              placeholder="Jane Doe"
              required
              autoComplete="name"
              value={name}
              onChange={(event) => {
                setName(event.target.value);
              }}
            />
            <Field
              label="Billing Address"
              id="address"
              type="text"
              placeholder="Billing Address"
              autoComplete="address"
              value={address}
              onChange={(event) => {
                setAddress(event.target.value);
              }}
            />
            <Field
              label="BILLING CITY"
              id="city"
              type="text"
              placeholder="BILLING CITY"
              autoComplete="city"
              value={city}
              onChange={(event) => {
                setCity(event.target.value);
              }}
            />
            <Field
              label="BILLING STATE"
              id="state"
              type="text"
              placeholder="BILLING CITY"
              autoComplete="state"
              value={state}
              onChange={(event) => {
                setState(event.target.value);
              }}
            />
            <Field
              label="BILLING ZIP"
              id="zip"
              type="text"
              placeholder="BILLING ZIP"
              autoComplete="zip"
              value={zip}
              onChange={(event) => {
                setZip(event.target.value);
              }}
            />
          </fieldset>
          {error && <ErrorMessage>{error.message}</ErrorMessage>}
          <SubmitButton
            processing={paymentLoading}
            error={error}
            disabled={!stripe}
          >
            Done
          </SubmitButton>
        </form>
      </div>
    </div>
  );
}

export default PaymentCardForm;



// WEBPACK FOOTER //
// ./src/components/checkout/PaymentCardForm.js